import Buttons from '../buttons';
import Icon from '@klv/atoms/icon';
import { generateClassName, getColorScheme } from '@klv/shared/utils/functions';

import * as s from './styles/card.module.css';

import type { ICard } from './types';
import type { TIconName } from '@klv/atoms/icon/types';
import type { TBaseProps } from '@klv/shared/types';


const Card = ({
  bodyCopy,
  buttons,
  className,
  icon = { iconName: '' },
  variant = 'light',
  title,
  iconSize = 3.2,
  ...props
}: ICard & TBaseProps<'div'>) => (
  <div
    {...props}
    className={generateClassName([s.card, className])}
    data-color-scheme={getColorScheme(variant)}
  >
    <Icon
      className={generateClassName([s.cardIcon])}
      color='currentColor'
      iconName={icon?.iconName as TIconName}
      size={iconSize}
    />
    <h3 className={generateClassName([s.cardHeadline, 'h6', 'medium'])}>
      {title}
    </h3>
    <div
      className={generateClassName([s.cardCopy, 'p2'])}
      dangerouslySetInnerHTML={{ __html: bodyCopy }}
    />
    {buttons !== undefined && (
      <Buttons
        className={s.cardButtons}
        buttonColor={variant === 'light' ? 'dark' : 'light'}
        buttons={buttons}
        variants={['tertiary']}
      />
    )}
  </div>
);

export default Card;
